import React, { useEffect, useRef, useState } from 'react'
import { Column } from 'primereact/column'
import IsCstService from './isCstService'
import FormList from 'base/FormList'

export default function IsCstList() {

    const [service] = useState(() => new IsCstService())
    const toast = useRef(null)
    const searchData = {
        pkName: 'codigo_iscst',
        dsName: 'descricao_iscst',
        mainField: { name: 'descricao_iscst', label: 'Descrição' },
        advFields: [
            { name: 'codigo_iscst', label: 'Código', type: 'string', inputMode: 'text' },
            { name: 'descricao_iscst', label: 'Descrição', type: 'string', inputMode: 'text' },
        ]
    }

    useEffect(() => {
    }, [service])

    return (
        <FormList service={service} toast={toast} searchData={searchData} showActions={true}>
            <Column field="codigo_iscst" sortable header="Código"></Column>
            <Column field="descricao_iscst" sortable header="Descrição"></Column>
        </FormList>
    )
}
